import e from"react";import"./MenuOptions.css.js";const t=({children:t,onClick:n,...o})=>e.createElement("div",{...o,className:"context-menu-option",onClick:n,tabIndex:0},t);export{t as MenuOption};
